<template>

<div class="slot" v-if="item.capacity && item.count">

    <div v-for="index in item.capacity" :key="index" class="slot-seat" :class="{'is-active': index <= item.count.filled}"></div>

</div>

</template>

<script>

export default {

	props: ['item']

}

</script>

<style scoped>

.slot {
    display: flex;
    padding-top: 1px;
}

.slot-seat {
    max-width: 10px;
    flex-grow: 1;
    height: 10px;
    margin: 1px 1px 0px 0px;
    background-color: #ddd;
}

.slot-seat:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.slot-seat:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.slot-seat.is-active {
	background-color: #4082d3;
}

</style>
